// services/adminAPI.js - UPDATED with user management endpoints

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Helper function to get auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
};

// Helper function to handle API responses
const handleResponse = async (response) => {
  const data = await response.json();
  
  if (!response.ok) {
    throw new Error(data.error || data.message || 'API request failed');
  }
  
  return data;
};

export const adminAPI = {
  // ✅ EXISTING: Payment Management
  async getPendingPayments() {
    try {
      const response = await fetch(`${API_BASE}/admin/payments/pending`, {
        method: 'GET',
        headers: getAuthHeaders()
      });
      
      return await handleResponse(response);
    } catch (error) {
      console.error('❌ Error fetching pending payments:', error);
      throw error;
    }
  },

  async verifyPayment(paymentId, data) {
    try {
      const response = await fetch(`${API_BASE}/admin/payments/${paymentId}/verify`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(data)
      });
      
      return await handleResponse(response);
    } catch (error) {
      console.error('❌ Error verifying payment:', error);
      throw error;
    }
  },

  async getAdminStats() {
    try {
      const response = await fetch(`${API_BASE}/admin/stats`, {
        method: 'GET',
        headers: getAuthHeaders()
      });
      
      return await handleResponse(response);
    } catch (error) {
      console.error('❌ Error fetching admin stats:', error);
      throw error;
    }
  },

  // ✅ NEW: User Management
  async getAllUsers(params = {}) {
    try {
      const queryParams = new URLSearchParams({
        page: params.page || 1,
        limit: params.limit || 20,
        search: params.search || '',
        sortBy: params.sortBy || 'createdAt',
        order: params.order || 'desc'
      });

      const response = await fetch(`${API_BASE}/admin/users?${queryParams}`, {
        method: 'GET',
        headers: getAuthHeaders()
      });
      
      return await handleResponse(response);
    } catch (error) {
      console.error('❌ Error fetching users:', error);
      throw error;
    }
  },

  async updateUserRenders(userId, data) {
    try {
      const response = await fetch(`${API_BASE}/admin/users/${userId}/renders`, {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: JSON.stringify(data)
      });
      
      return await handleResponse(response);
    } catch (error) {
      console.error('❌ Error updating user renders:', error);
      throw error;
    }
  },

  async deleteUser(userId, data) {
    try {
      const response = await fetch(`${API_BASE}/admin/users/${userId}`, {
        method: 'DELETE',
        headers: getAuthHeaders(),
        body: JSON.stringify(data)
      });
      
      return await handleResponse(response);
    } catch (error) {
      console.error('❌ Error deleting user:', error);
      throw error;
    }
  },

  // ✅ UTILITY: Test admin connection
  async testAdminConnection() {
    try {
      const response = await fetch(`${API_BASE}/admin/stats`, {
        method: 'GET',
        headers: getAuthHeaders()
      });
      
      return {
        success: response.ok,
        status: response.status,
        timestamp: new Date().toISOString()
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        timestamp: new Date().toISOString()
      };
    }
  }
};